/**
 * GoDatePipe created by karora on 14/03/17.
 */
import { Pipe, PipeTransform } from '@angular/core';
import {AppComponent} from '../app.component';
/*
 * Format a stringified ISO8601 date more prettily
 */
@Pipe({name: 'godate'})
export class GoDatePipe implements PipeTransform {
  transform(value: string): string {
    try {
      let d = new Date(value);
      if (isNaN(d.getTime()) || (d.valueOf() === 0)) {
        return '';
      }
      if ((d.getUTCHours() * 3600 + d.getUTCMinutes() * 60 + d.getUTCSeconds()) === 0) {
        return AppComponent.zpad(d.getUTCFullYear(), 4) +
          '-' + AppComponent.zpad(1 + d.getUTCMonth(), 2) +
          '-' + AppComponent.zpad(d.getUTCDate(), 2);
      }
      return AppComponent.zpad(d.getFullYear(), 4) +
        '-' + AppComponent.zpad(1 + d.getMonth(), 2) +
        '-' + AppComponent.zpad(d.getDate(), 2) +
        'T' + AppComponent.zpad(d.getHours(), 2) +
        ':' + AppComponent.zpad(d.getMinutes(), 2) +
        ':' + AppComponent.zpad(d.getSeconds(), 2);
    } catch (err) {
      console.log(err);
      return value;
    }
  }
}
